
/**
 * Security Headers Configuration for CSR (Client-Side Rendering)
 * Focus on client-side API request headers
 */

// Headers specifically for API requests (client-side)
export const getApiSecurityHeaders = () => {
  return {
    // No backend reads this. It is the legacy XHR marker some frameworks treat
    // as a CSRF signal; bearer-token auth needs no CSRF token.
    'X-Requested-With': 'XMLHttpRequest',
    
    // Content negotiation
    'Accept': 'application/json',
    
    // Request identification for security monitoring. Use VITE_CACHE_VERSION —
    // the real build id defined in vite.config (<pkg-version>-<timestamp>) —
    // not VITE_APP_VERSION, which is never defined at build so it silently fell
    // back to the dead '1.0.0', making admin traffic unmeasurable in CloudWatch
    // The web app carries the same header for the same reason.
    'X-Client-Version': import.meta.env.VITE_CACHE_VERSION || '1.0.0',
    'X-Request-Source': 'web-client',
  };
};

// Validate security headers in API responses (for monitoring)
export const validateSecurityHeaders = (response) => {
  const requiredHeaders = [
    'X-Content-Type-Options',
    'X-Frame-Options',
    'Content-Security-Policy'
  ];
  
  const missingHeaders = requiredHeaders.filter(
    header => !response.headers[header.toLowerCase()]
  );
  
  if (missingHeaders.length > 0) {
    console.warn('[Security] Missing security headers in API response:', missingHeaders);
    console.warn('[Security] These should be set by your backend server');
  }
  
  return missingHeaders.length === 0;
};

export default {
  getApiSecurityHeaders,
  validateSecurityHeaders,
};
